import { EcoFuture } from '@/dto/scenario/eco/EcoFuture';

import { EcoCapexExt } from './EcoCapexExt';

export class EcoFutureExt extends EcoCapexExt {
  public static fromDto(dto: EcoFuture): EcoFutureExt {
    return new EcoFutureExt({
      pvInverter: dto.pvInverter,
      pvInverterAcdcRatio: dto.pvInverterAcdcRatio,

      generatorBeforeDayCost: dto.generatorBeforeDayCost,
      generatorBeforeNightCost: dto.generatorBeforeNightCost,
      generatorAfterDayCost: dto.generatorAfterDayCost,
      generatorAfterNightCost: dto.generatorAfterNightCost,

      batteryModule: dto.batteryModule,
      batteryPriceReduction: dto.batteryPriceReduction,
      batteryInverter: dto.batteryInverter,
      generatorCostType1: dto.generatorCostType1,
      generatorCostType2: dto.generatorCostType2
    } as EcoFutureExt);
  }

  public toDto(): EcoFuture {
    return new EcoFuture({
      pvInverter: this.pvInverter,
      pvInverterAcdcRatio: this.pvInverterAcdcRatio,

      generatorBeforeDayCost: this.generatorBeforeDayCost,
      generatorBeforeNightCost: this.generatorBeforeNightCost,
      generatorAfterDayCost: this.generatorAfterDayCost,
      generatorAfterNightCost: this.generatorAfterNightCost,

      batteryModule: this.batteryModule,
      batteryPriceReduction: this.batteryPriceReduction,
      batteryInverter: this.batteryInverter,
      generatorCostType1: this.generatorCostType1,
      generatorCostType2: this.generatorCostType2
    });
  }
}
